export default "__VITE_ASSET__30e9f485__"